<template>
  <div>
    <ul class="nav nav-tabs">
      <li class="nav-item">
        <router-link :to="general" class="nav-link">
          <i class="fa fa-list-alt mr-1"/>General
        </router-link>
      </li>
      <li class="nav-item">
        <router-link :to="warehouseLink" class="nav-link">
          <i class="fa fa-home mr-1"/>Warehouses
        </router-link>
      </li>
      <li class="nav-item">
        <router-link :to="mfrLink" class="nav-link">
          <i class="fa fa-industry mr-1"/>Manufacturers
        </router-link>
      </li>
      <li class="nav-item">
        <router-link :to="shippingProvidersLink" class="nav-link">
          <i class="fa fa-truck mr-1"/>Shipping Providers
        </router-link>
      </li>
      <li class="nav-item">
        <router-link :to="shippingMethodsLink" class="nav-link">
          <i class="fa fa-truck mr-1"/>Shipping Methods
        </router-link>
      </li>
      <li class="nav-item">
        <router-link :to="questionsLink" class="nav-link">
          <i class="fa fa-question-circle mr-1"/>Interview Questions
        </router-link>
      </li>
      <li class="nav-item">
        <router-link :to="emailTemplateLink" class="nav-link">
          <i class="fa fa-envelope mr-1"/>Email Template
        </router-link>
      </li>      
      <li class="nav-item">
        <router-link :to="billingLink" class="nav-link">
          <i class="fa fa-first-order mr-1"/>Billing Terms
        </router-link>
      </li>
      <li class="nav-item">
        <router-link :to="ncmLink" class="nav-link">
          <i class="fa fa-codepen mr-1"/>NCM Codes
        </router-link>
      </li>
      <li class="nav-item">
        <router-link :to="currenciesLink" class="nav-link">
          <i class="fa fa-dollar mr-1"/>Currency
        </router-link>
      </li>
      <li class="nav-item">
        <router-link :to="attributesLink" class="nav-link">
          <i class="fa fa-address-card mr-1"/>Attributes
        </router-link>
      </li>
      <li class="nav-item">
        <router-link :to="commissionRateLink" class="nav-link">
          <i class="fa fa-dollar mr-1"/>Commission Rate
        </router-link>
      </li>
    </ul>
    <router-view></router-view>
  </div>
</template>
<script>
  import { mapState, mapActions, mapGetters, mapMutations } from 'vuex';

  export default {
    metaInfo: () => ({
      title: 'New Erp',
    }),
    data() {
      return {};
    },
    computed: {
      ...mapGetters('lookupMgmt', ['lastOpenedTab',
        'warehouseLink',
        'mfrLink',
        'shippingProvidersLink',
        'shippingMethodsLink',
        'emailTemplateLink',
        'questionsLink',
        'general',
        'billingLink',
        'ncmLink',
        'currenciesLink',
        'attributesLink', 
        'commissionRateLink'
      ]),
    },
    methods: {
      ...mapMutations('lookupMgmt', ['setItem']),
    },
    watch: {},
    mounted() {
      if (!this.lastOpenedTab) {
        this.setItem({ resource: 'general', payload: this.general });
        this.setItem({ resource: 'lastOpenedTab', payload: this.usersLink });
      }
      if (this.$route.meta.controlLink) {
        this.setItem({ resource: this.$route.meta.controlLink, payload: this.$route.fullPath });
        this.setItem({ resource: 'lastOpenedTab', payload: this.$route.fullPath });
      }
    },
  };
</script>

<style scoped>
.new-offer-button {
  right: 10px;
  position: absolute;
  top: 4px;
}
</style>
